<div class="read-bar"></div>
<app-alert></app-alert>
<app-header></app-header>
<section class='content'>
  <router-outlet></router-outlet>
</section>
<!-- <app-reviews></app-reviews> -->
<app-footer></app-footer>

